<template>
  <!-- 查看导入结果 -->
  <el-dialog
    title="查看导入结果"
    :visible.sync="resultVisible"
    width="800px"
    :before-close="closeResultDia"
    :close-on-click-modal="false"
    class="audit-record"
    :append-to-body="true"
  >
    <div class="list-box">
      <el-table
        max-height="391"
        :data="tableData"
        ref="tableData"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" width="60px">
          <template #default="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="导入时间"
          min-width="70"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="memberName"
          label="操作人"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column prop="" label="导入结果" min-width="90" align="center">
          <template #default="scope">
            <span
              class="table-handle-btn"
              @click="downloadFile(scope.row.fileName, scope.row.fileUrl)"
            >
              下载导入结果
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px; color: #F0250F;">导入结果只保留最近10次的记录</div>
    </div>
    <div slot="footer">
      <div class="default-btn btn" @click="closeResultDia">关闭</div>
    </div>
  </el-dialog>
</template>

<script>
import Api from "@/modules/projectA/api/agreement/index";
export default {
  props: {
    resultVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableLoading: false,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [],
    };
  },
  watch: {
    resultVisible(newVal) {
      if (newVal) {
        this.getList(this.listQuery);
      }
    },
  },
  methods: {
    // 获取列表数据
    async getList() {
      try {
        this.tableLoading = true;
        const res = await Api.importResult();
        if (res.code === "200") {
          this.tableData = [...res.data];
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.tableLoading = false;
      }
    },
    downloadFile(fileName, fileUrl) {
      const downloadRes = async () => {
        let response = await fetch(fileUrl);
        let blob = await response.blob();
        let objectUrl = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    closeResultDia() {
      this.$emit("update:resultVisible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .table-handle-btn {
    min-width: 80px;
    height: 30px;
    line-height: 30px;
    color: #0064c8;
    cursor: pointer;
    padding: 0;
    border-radius: 0;
    &:hover {
      text-decoration: underline;
    }
  }
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
// 列表重置样式-结束

// dialog 重置样式开始
::v-deep.el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 8px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
// dialog 重置样式结束

.audit-record {
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }
    }
  }

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding: 10px;
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }

    .default-btn {
      background: #fff;
      border: 1px solid #dcdfe6;
      &:hover {
        border-color: #2587ff;
        color: #2587ff;
      }
    }
  }
}
</style>
